// removed by extract-text-webpack-plugin
module.exports = {"heading":"style__heading__34msA","content":"style__content__eJGEt"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/SecurityRulesPage/style.css
// module id = 2524
// module chunks = 0